const state = {
  calls: []
};

const mutations = {
  SET_CALLS(state, calls) {
    state.calls = calls;
  },
  ADD_CALL(state, call) {
    state.calls.push(call);
  },
  REMOVE_CALL(state, phone) {
    state.calls = state.calls.filter(call => call.phone !== phone);
  }
};

const actions = {
  loadMissedCalls({ commit }) {
    const calls = JSON.parse(localStorage.getItem('missedCalls')) || [];
    commit('SET_CALLS', calls);
  },
  addMissedCall({ commit, state }, call) {
    commit('ADD_CALL', call);
    localStorage.setItem('missedCalls', JSON.stringify(state.calls));
  },
  removeMissedCall({ commit, state }, phone) {
    commit('REMOVE_CALL', phone);
    localStorage.setItem('missedCalls', JSON.stringify(state.calls));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
